import { GlobalAxios } from "../axios/axios-config";
import { IEncounterDataZLog } from "../models/encounter-data-z-log";

const ENCOUNTER_DATA_Z_LOG_ROUTE =
  process.env.REACT_APP_EXTERNAL + "/api/v1/EncounterDataZLog";

export const getEncounterDataZLog = (encounterDataIdentifier: number) => {
  return GlobalAxios.get<IEncounterDataZLog>(ENCOUNTER_DATA_Z_LOG_ROUTE, {
    params: {
      encounterDataIdentifier,
    },
  });
};
